module.exports = "/matchcenter-staging/assets/images/ote_sport_1.635fdfdb9ffdfc890633bfde3512bbc9.png";